import store from "../redux/store";

export const RISTA_API_URL = process.env.REACT_APP_RISTA_BASE_API_URL;
export const RISTA_CDN_URL = process.env.REACT_APP_RISTA_ITEM_BASE_URL;
export const DOTPE_CDN_URL = process.env.REACT_APP_CDN_ORACLE_URL;
export const RISTA_CUSTOM_URL = "business/services/br/"
//export const RISTA_API_URL = "http://localhost:8000/business/services/bn";
//export const RISTA_API_URL = "https://apps.dev.ristasales.com/business/services/bn/";

export const getImageCdnUrl = (imageId: string, type: string = 'small') => {
  let staticFolder = store.getState()?.businessReducer?.businessData?.staticFolder || '';
  let imgUrl = `${RISTA_CDN_URL}${staticFolder}images/${imageId}/${type}`;
  return imgUrl;
}
